"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Error_svg_1 = __importDefault(require("./icons/dashboard/Error.svg"));
const Warning_svg_1 = __importDefault(require("./icons/dashboard/Warning.svg"));
const Success_svg_1 = __importDefault(require("./icons/dashboard/Success.svg"));
const Running_svg_1 = __importDefault(require("./icons/dashboard/Running.svg"));
const Archive32_svg_1 = __importDefault(require("./icons/dashboard/Archive32.svg"));
const Average_workers_wait_time32_svg_1 = __importDefault(require("./icons/dashboard/Average_workers_wait_time32.svg"));
const Azure_files32_svg_1 = __importDefault(require("./icons/dashboard/Azure_files32.svg"));
const Azure_virtual_machines32_svg_1 = __importDefault(require("./icons/dashboard/Azure_virtual_machines32.svg"));
const Backup32_svg_1 = __importDefault(require("./icons/dashboard/Backup32.svg"));
const Bottleneck_region32_svg_1 = __importDefault(require("./icons/dashboard/Bottleneck_region32.svg"));
const EC2_Instance32_svg_1 = __importDefault(require("./icons/dashboard/EC2_Instance32.svg"));
const EFS32_svg_1 = __importDefault(require("./icons/dashboard/EFS32.svg"));
const Googl_virtual_machine32_svg_1 = __importDefault(require("./icons/dashboard/Googl_virtual_machine32.svg"));
const Allowed_workers32_svg_1 = __importDefault(require("./icons/dashboard/Allowed_workers32.svg"));
const RDS_Instance32_svg_1 = __importDefault(require("./icons/dashboard/RDS_Instance32.svg"));
const Replica_snapshots32_svg_1 = __importDefault(require("./icons/dashboard/Replica_snapshots32.svg"));
const Snapshot32_svg_1 = __importDefault(require("./icons/dashboard/Snapshot32.svg"));
const Tota_workers_wait_time32_svg_1 = __importDefault(require("./icons/dashboard/Tota_workers_wait_time32.svg"));
const ArrowDown_svg_1 = __importDefault(require("./icons/controls/ArrowDown.svg"));
const ArrowRight_svg_1 = __importDefault(require("./icons/controls/ArrowRight.svg"));
const ArrowUp_svg_1 = __importDefault(require("./icons/controls/ArrowUp.svg"));
const Asc_svg_1 = __importDefault(require("./icons/controls/Asc.svg"));
const Back_svg_1 = __importDefault(require("./icons/controls/Back.svg"));
const Calendar_svg_1 = __importDefault(require("./icons/controls/Calendar.svg"));
const CheckBoxDeselected_svg_1 = __importDefault(require("./icons/controls/CheckBoxDeselected.svg"));
const CheckBoxDeselectedDisabled_svg_1 = __importDefault(require("./icons/controls/CheckBoxDeselectedDisabled.svg"));
const CheckBoxIndeterminate_svg_1 = __importDefault(require("./icons/controls/CheckBoxIndeterminate.svg"));
const CheckBoxIndeterminateDisabled_svg_1 = __importDefault(require("./icons/controls/CheckBoxIndeterminateDisabled.svg"));
const CheckBoxSelected_svg_1 = __importDefault(require("./icons/controls/CheckBoxSelected.svg"));
const CheckBoxSelectedDisabled_svg_1 = __importDefault(require("./icons/controls/CheckBoxSelectedDisabled.svg"));
const ClearFolder_svg_1 = __importDefault(require("./icons/controls/ClearFolder.svg"));
const Desc_svg_1 = __importDefault(require("./icons/controls/Desc.svg"));
const DialogClose_svg_1 = __importDefault(require("./icons/controls/DialogClose.svg"));
const Fwd_svg_1 = __importDefault(require("./icons/controls/Fwd.svg"));
const NavMenuCurrent_svg_1 = __importDefault(require("./icons/controls/NavMenuCurrent.svg"));
const Next_svg_1 = __importDefault(require("./icons/controls/Next.svg"));
const PanelClose_svg_1 = __importDefault(require("./icons/controls/PanelClose.svg"));
const RadiobuttonChecked_svg_1 = __importDefault(require("./icons/controls/RadiobuttonChecked.svg"));
const RadiobuttonCheckedDisabled_svg_1 = __importDefault(require("./icons/controls/RadiobuttonCheckedDisabled.svg"));
const RadioButtonUnchecked_svg_1 = __importDefault(require("./icons/controls/RadioButtonUnchecked.svg"));
const RadioButtonUncheckedDisabled_svg_1 = __importDefault(require("./icons/controls/RadioButtonUncheckedDisabled.svg"));
const Rwd_svg_1 = __importDefault(require("./icons/controls/Rwd.svg"));
const Search_svg_1 = __importDefault(require("./icons/controls/Search.svg"));
const ShowPassword_svg_1 = __importDefault(require("./icons/controls/ShowPassword.svg"));
const TableOptions_svg_1 = __importDefault(require("./icons/controls/TableOptions.svg"));
const ToggleSwitchOff_svg_1 = __importDefault(require("./icons/controls/ToggleSwitchOff.svg"));
const ToggleSwitchOffDisabled_svg_1 = __importDefault(require("./icons/controls/ToggleSwitchOffDisabled.svg"));
const ToggleSwitchOn_svg_1 = __importDefault(require("./icons/controls/ToggleSwitchOn.svg"));
const WizardCurrentStep_svg_1 = __importDefault(require("./icons/controls/WizardCurrentStep.svg"));
const Run_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Run/Run.svg"));
const Error_svg_2 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Error/Error.svg"));
const Warning_svg_2 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Warning/Warning.svg"));
const Ok_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Ok/Ok.svg"));
const Info_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Info/Info.svg"));
const ICONS = {
    common: {
        run: Run_svg_1.default,
        error: Error_svg_2.default,
        warning: Warning_svg_2.default,
        ok: Ok_svg_1.default,
        success: Ok_svg_1.default,
        info: Info_svg_1.default,
    },
    control: {
        ArrowDown: ArrowDown_svg_1.default,
        ArrowRight: ArrowRight_svg_1.default,
        ArrowUp: ArrowUp_svg_1.default,
        Asc: Asc_svg_1.default,
        Back: Back_svg_1.default,
        Calendar: Calendar_svg_1.default,
        CheckBoxDeselected: CheckBoxDeselected_svg_1.default,
        CheckBoxDeselectedDisabled: CheckBoxDeselectedDisabled_svg_1.default,
        CheckBoxIndeterminate: CheckBoxIndeterminate_svg_1.default,
        CheckBoxIndeterminateDisabled: CheckBoxIndeterminateDisabled_svg_1.default,
        CheckBoxSelected: CheckBoxSelected_svg_1.default,
        CheckBoxSelectedDisabled: CheckBoxSelectedDisabled_svg_1.default,
        ClearFolder: ClearFolder_svg_1.default,
        Desc: Desc_svg_1.default,
        DialogClose: DialogClose_svg_1.default,
        Fwd: Fwd_svg_1.default,
        NavMenuCurrent: NavMenuCurrent_svg_1.default,
        Next: Next_svg_1.default,
        PanelClose: PanelClose_svg_1.default,
        RadiobuttonChecked: RadiobuttonChecked_svg_1.default,
        RadiobuttonCheckedDisabled: RadiobuttonCheckedDisabled_svg_1.default,
        RadioButtonUnchecked: RadioButtonUnchecked_svg_1.default,
        RadioButtonUncheckedDisabled: RadioButtonUncheckedDisabled_svg_1.default,
        Rwd: Rwd_svg_1.default,
        Search: Search_svg_1.default,
        ShowPassword: ShowPassword_svg_1.default,
        TableOptions: TableOptions_svg_1.default,
        ToggleSwitchOff: ToggleSwitchOff_svg_1.default,
        ToggleSwitchOffDisabled: ToggleSwitchOffDisabled_svg_1.default,
        ToggleSwitchOn: ToggleSwitchOn_svg_1.default,
        WizardCurrentStep: WizardCurrentStep_svg_1.default,
    },
    dashboard: {
        error: Error_svg_1.default,
        warning: Warning_svg_1.default,
        success: Success_svg_1.default,
        running: Running_svg_1.default,
        archive: Archive32_svg_1.default,
        avgWaitTime: Average_workers_wait_time32_svg_1.default,
        azureFiles: Azure_files32_svg_1.default,
        azureVM: Azure_virtual_machines32_svg_1.default,
        backup: Backup32_svg_1.default,
        regionNote: Bottleneck_region32_svg_1.default,
        ec2Instance: EC2_Instance32_svg_1.default,
        efs: EFS32_svg_1.default,
        googleVM: Googl_virtual_machine32_svg_1.default,
        allowedWorkers: Allowed_workers32_svg_1.default,
        rdsInstance: RDS_Instance32_svg_1.default,
        replicaSnapshot: Replica_snapshots32_svg_1.default,
        snapshot: Snapshot32_svg_1.default,
        totalWaitTime: Tota_workers_wait_time32_svg_1.default,
    },
};
exports.default = ICONS;
//# sourceMappingURL=icons.js.map